var _circle, _circle2, _circle3, _circle4, _circle5, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcosystemMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4615,
    cy: 6.02404,
    r: 1.86154,
    stroke: "black",
    strokeWidth: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.73107,
    cy: 11.4459,
    r: 1.86154,
    stroke: "black",
    strokeWidth: 1.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4615,
    cy: 18.024,
    r: 1.86154,
    stroke: "black",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.46154,
    cy: 6.02404,
    r: 1.86154,
    stroke: "black",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7293,
    cy: 12.0613,
    r: 2.47692,
    stroke: "black",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.0024,
    y1: 14.7164,
    x2: 18.4639,
    y2: 17.1779,
    stroke: "black",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.96094,
    y1: 12.0797,
    x2: 11.884,
    y2: 12.0797,
    stroke: "black",
    strokeWidth: 1.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5992,
    y1: 9.81127,
    x2: 18.5992,
    y2: 7.11889,
    stroke: "black",
    strokeWidth: 1.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.61567,
    y1: 7.33355,
    x2: 11.0772,
    y2: 9.79509,
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystemMenuIcon);
export default __webpack_public_path__ + "static/media/ecosystem-menu-icon.d6c5eedb20b4d33e1e52fa308b46a51d.svg";
export { ForwardRef as ReactComponent };